// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getDateFull from "@store/Framework/Common/Utilities/getDateFull";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface Props {
    publicationDate: Date;
    hideHourMinutes: boolean;
    extendedStyles?: BlogDateStyles;
}

export interface BlogDateStyles {
    dateWrapper?: InjectableCss;
    textDate?: TypographyPresentationProps;
}

export const blogDateStyles: BlogDateStyles = {
    dateWrapper: {
        css: css`
            padding-bottom: ${pxToRem(10)};
        `,
    },
    textDate: {
        css: css`
            display: block;
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
};

const BlogDate = ({ publicationDate, hideHourMinutes, extendedStyles }: Props) => {
    const styles = useMergeProps(blogDateStyles, extendedStyles);

    return (
        <StyledWrapper {...styles.dateWrapper}>
            <Typography {...styles.textDate}>
                {publicationDate && getDateFull(publicationDate, hideHourMinutes)}
            </Typography>
        </StyledWrapper>
    );
};

export default BlogDate;
